import { memo } from 'react';

import { Button, type ButtonProps } from '@air/primitive-button';
import { cn } from '@air/utils-tailwind';

import Linkify from '~/components/Linkify';

type EditableMultilineTextTriggerButtonProps = {
  placeholder?: string;
  value?: string;
} & Omit<ButtonProps, 'children'>;

export const EditableMultilineTextTriggerButton = memo(
  ({ placeholder, className, style, value, ...restProps }: EditableMultilineTextTriggerButtonProps) => {
    return (
      <Button
        className={cn(
          'whitespace-pre-wrap px-2 py-1 text-left font-normal text-12',
          value ? 'text-grey-11' : 'text-grey-7',
          className,
        )}
        appearance="ghost"
        color="grey"
        style={{ wordBreak: 'break-word', ...style }}
        {...restProps}
      >
        <div className="size-full overflow-hidden text-left">
          {value ? (
            <>
              <Linkify>{value}</Linkify>
              {/**
               * This is need to ensure that newlines will always show the proper height
               * Without this, if user types a newline, the height of the button will not change
               */}
              {value.includes('\n') && <>&nbsp;</>}
            </>
          ) : (
            placeholder
          )}
        </div>
      </Button>
    );
  },
);

EditableMultilineTextTriggerButton.displayName = 'EditableMultilineTextTriggerButtonProps';
